import type { ReactNode } from 'react';
import { cn } from './cn';

/** A key figure with its caption (turnover summary cards, FR-TURN-004). */
export function StatTile({
  label,
  value,
  tone = 'plain',
}: {
  label: string;
  value: ReactNode;
  tone?: 'plain' | 'warning';
}) {
  return (
    <div
      role="group"
      aria-label={label}
      className={cn(
        'flex flex-col gap-1 rounded-card border bg-surface p-4 shadow-sm',
        tone === 'warning' ? 'border-amber-200 bg-amber-50/60' : 'border-border',
      )}
    >
      <span className="text-2xl font-semibold tabular-nums" data-stat="value">
        {value}
      </span>
      <span className="text-sm text-ink-muted" data-stat="label">
        {label}
      </span>
    </div>
  );
}
